import {
    inject,
    Injectable
} from "@angular/core";

import {
    TranslateService
} from "@ngx-translate/core";

import {
    TilbyCurrencyPipe
} from "@tilby/tilby-ui-lib/pipes/tilby-currency";

import {
    cashdrawerPaymentDialog
} from "app/ajs-upgraded-providers";

import {
    GloryCashdrawerDriverService
} from "src/app/features/digital-payments";

import {
    DigitalPaymentHandler,
    DigitalPaymentHandlerOptions,
    DigitalPaymentHandlerResult
} from "src/app/shared/model/digital-payments.model";

import {
    DocumentPrintHook,
} from "src/app/shared/model/document-printer.model";

import {
    PaymentMethods,
    SalesPayments
} from "tilby-models";

@Injectable({
    providedIn: 'root'
})
export class GloryCashdrawerService implements DigitalPaymentHandler, DocumentPrintHook {
    private readonly cashdrawerPaymentDialog = inject(cashdrawerPaymentDialog);
    private readonly gloryCashdrawerDriver = inject(GloryCashdrawerDriverService);
    private readonly tilbyCurrencyPipe = inject(TilbyCurrencyPipe);
    private readonly translateService = inject(TranslateService);

    public getPaymentReceipt(paymentMethod: SalesPayments): string {
        if(!paymentMethod.payment_data) {
            return "";
        }

        try {
            const transaction = JSON.parse(paymentMethod.payment_data);
    
            const receiptTail = [
                "",
                "Dettaglio pagamento",
                `Da pagare ${this.tilbyCurrencyPipe.transform(transaction.toPay).padStart(22, ' ')}`,
                `Pagato ${this.tilbyCurrencyPipe.transform(transaction.paid).padStart(25, ' ')}`,
                `Resto erogato ${this.tilbyCurrencyPipe.transform(transaction.changeGiven).padStart(18, ' ')}`,
                `Resto non erogato ${this.tilbyCurrencyPipe.transform(transaction.changeNotGiven).padStart(14, ' ')}`,
            ];
    
            return receiptTail.join('\n');
        } catch(err) {
            return "";
        }
    }

    public async payment(amount: number, options: DigitalPaymentHandlerOptions): Promise<DigitalPaymentHandlerResult> {
        const paymentMethod = options.paymentMethod;

        if (!paymentMethod.bundle_name) {
            throw this.translateService.instant('DIGITAL_PAYMENTS.COMMON.BUNDLE_NAME_NOT_FOUND');
        }

        return this.cashdrawerPaymentDialog.show(amount, paymentMethod, this.gloryCashdrawerDriver, "Cassetto Glory");
    }

    public async deposit(amount: number, options: { paymentMethod: PaymentMethods; }): Promise<DigitalPaymentHandlerResult> {
        const paymentMethod = options.paymentMethod;

        if (!paymentMethod.bundle_name) {
            throw this.translateService.instant('DIGITAL_PAYMENTS.COMMON.BUNDLE_NAME_NOT_FOUND');
        }

        return this.cashdrawerPaymentDialog.show(amount, options.paymentMethod, this.gloryCashdrawerDriver, "Cassetto Glory", 'DEPOSIT');
    }

    public async withdrawal(amount: number, options: { paymentMethod: PaymentMethods; }): Promise<DigitalPaymentHandlerResult | undefined> {
        const paymentMethod = options.paymentMethod;

        if (!paymentMethod.bundle_name) {
            throw this.translateService.instant('DIGITAL_PAYMENTS.COMMON.BUNDLE_NAME_NOT_FOUND');
        }

        return this.cashdrawerPaymentDialog.show(-amount, options.paymentMethod, this.gloryCashdrawerDriver, "Cassetto Glory", 'WITHDRAWAL');
    }

    public isEnabled(): boolean {
        return true;
    }
}